var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProtection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41141 15.8475C9.14664 15.9496 8.85333 15.9496 8.58855 15.8475V15.8475C6.52077 15.0367 4.74527 13.6216 3.49356 11.7869C2.24186 9.95214 1.57202 7.7828 1.57141 5.56174V2.21317C1.57141 1.91007 1.69182 1.61937 1.90615 1.40505C2.12047 1.19072 2.41116 1.07031 2.71427 1.07031H15.2857C15.5888 1.07031 15.8795 1.19072 16.0938 1.40505C16.3081 1.61937 16.4286 1.91007 16.4286 2.21317V5.55031C16.4302 7.77332 15.7615 9.94516 14.5096 11.7822C13.2578 13.6192 11.481 15.036 9.41141 15.8475V15.8475Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2417 12.7639C5.26594 11.2272 7.01474 10.2148 8.99999 10.2148C10.9852 10.2148 12.734 11.2272 13.7583 12.7639",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 8.49833C10.4202 8.49833 11.5714 7.34706 11.5714 5.9269C11.5714 4.50674 10.4202 3.35547 9.00002 3.35547C7.57986 3.35547 6.42859 4.50674 6.42859 5.9269C6.42859 7.34706 7.57986 8.49833 9.00002 8.49833Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProtection);
export default __webpack_public_path__ + "static/media/UserProtection.b2198aca72bcfaf28606d99b2c01f6ba.svg";
export { ForwardRef as ReactComponent };